<section class="users-edit">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- Nav-tabs -->
            <ul
              ngbNav
              #nav="ngbNav"
              [activeId]="1"
              class="nav-tabs justify-content-left"
            >
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-user mr-1"></i>
                  <span class="d-none d-sm-block">Account</span>
                </a>
                <ng-template ngbNavContent>
                  <!-- Account content starts -->
                  <div class="mt-2" id="account">
                    <!-- Media object starts -->
                    <!-- <div class="media">
                        <img  *ngIf="imgUrl" [src]="imgUrl" alt="user edit avatar"
                          class="users-avatar-shadow avatar mr-3 rounded-circle" height="64" width="64">
                          <img  *ngIf="!imgUrl" [src]="imageUrl + attendanceData?.image" alt="user edit avatar"
                          class="users-avatar-shadow avatar mr-3 rounded-circle" height="64" width="64">
                          <div class="media-body">
                          <h4>{{attendanceData?.tagName}}</h4>
                          <div class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2">
                            <label class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset">Change 
                              <input type="file" #fileInput class="form-control" (change)="onSelectFile($event)" hidden/>
                              </label>
                            <button class="btn btn-sm bg-light-secondary ml-sm-2" (click)="resetImage()">Reset</button>
                          </div>
                        </div>
                      </div>  -->
                    <!-- Media object ends -->

                    <!-- Account form starts -->
                    <form>
                      <div class="row">
                        <div class="col-md">
                          <fieldset class="form-group">
                            <label for="name">Name</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="attendanceData.user.name"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter name"
                              #name readonly
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="startTime">StartTime</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="attendanceData.startTime"
                              [ngModelOptions]="{ standalone: true }"
                              id="startTime"
                              placeholder="Enter startTime"
                              #startTime
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="endTime">endTime</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="attendanceData.endTime"
                              [ngModelOptions]="{ standalone: true }"
                              id="endTime"
                              placeholder="Enter endTime"
                              #endTime
                            />
                          </fieldset>
                        </div>
                        <div class="col-md">
                          <fieldset class="form-group">
                            <label for="attendanceDate">attendanceDate</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="attendanceData.attendanceDate"
                              [ngModelOptions]="{ standalone: true }"
                              id="attendanceDate"
                              placeholder="Enter attendanceDate"
                              #attendanceDate readonly
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="notes">notes</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="attendanceData.notes"
                              [ngModelOptions]="{ standalone: true }"
                              id="notes"
                              placeholder="Enter notes"
                              #notes
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="task">task</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="attendanceData.task"
                              [ngModelOptions]="{ standalone: true }"
                              id="task"
                              placeholder="Enter task"
                              #task
                            />
                          </fieldset>
                        </div>
                        <div
                          class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                        >
                          <button
                            type="submit"
                            class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                            [disabled]="
                              name.value.length === 0 ||
                              startTime.value.lenth === 0 ||
                              endTime.value.lenth === 0 ||
                              attendanceDate.value.lenth === 0 ||
                              notes.value.lenth === 0 ||
                              task.value.lenth === 0
                            "
                            (click)="tagUpdate()"
                          >
                            Submit
                          </button>
                          <button
                            type="reset"
                            class="btn btn-secondary"
                            (click)="back()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                    <!-- Account form ends -->
                  </div>
                  <!-- Account content ends -->
                </ng-template>
              </li>
            </ul>
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
